import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_coach/athletes")({
  component: RouteComponent,
  ssr: true,
  staticData: {
    getBreadcrumb: ({ i18n }) => {
      return {
        href: "/athletes",
        label: i18n.t("athletesPage.breadcrumb"),
      };
    },
  },
});

function RouteComponent() {
  return <Outlet />;
}
